define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.push;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/push.js